import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import * as axios from 'axios';

export default {
    obterCargosAsync,
    enviarCargoAsync,
    editarCargoAsync,
    downloadLista
}

export const obterCargosAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Cargo/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarCargoAsync = async (descricao) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ descricao })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Cargo`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export const editarCargoAsync = async (id, descricao, ativo) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, descricao, ativo })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/Cargo/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleBadRequest400);
}

export function downloadLista() {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/Cargo/downloadCargos`,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            return { status: false };
        })
            .then((response) => {
                if (response.status === false)
                    return response;
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');

                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'cargos' + '.xlsx');
                document.body.appendChild(fileLink);

                fileLink.click();
            });
    } catch (e) {
        throw e;
    }
}